(ns practitest.frontend.components.grid.localstorage
  (:require [cljs.reader]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]))

(defn- localstorage-columns-widths-key [table-id]
  (when table-id
    (str table-id "-col-widths")))

(defn load-column-sizes
  [table-id]
  (when-let [key (localstorage-columns-widths-key table-id)]
    (try
      (cljs.reader/read-string (dom/get-item key))
      (catch js/Error e
        (js/console.warn e)))))

(defn save-column-sizes
  [table-id column-widths]
  (when-let [key (localstorage-columns-widths-key table-id)]
    (if (nil? column-widths)
      (dom/remove-item key)
      (dom/set-item key (pr-str column-widths)))))

(defn- localstorage-columns-settings-key [table-id]
  (when table-id
    (str table-id "-col-settings")))

(defn load-column-settings
  [table-id]
  (when-let [key (localstorage-columns-settings-key table-id)]
    (try
      (cljs.reader/read-string (dom/get-item key))
      (catch js/Error e
        (js/console.warn e)))))

(defn save-column-settings
  [table-id column-settings]
  (when-let [key (localstorage-columns-settings-key table-id)]
    (if (nil? column-settings)
      (dom/remove-item key)
      (dom/set-item key (pr-str column-settings)))))

(defn- per-page-key [table-id]
  (when table-id
    (str table-id "-per-page")))

(defn load-per-page
  [table-id]
  (when-let [key (per-page-key table-id)]
    (try
      (cljs.reader/read-string (dom/get-item key))
      (catch js/Error e
        (js/console.warn e)))))

(defn save-per-page
  [table-id per-page]
  (when-let [key (per-page-key table-id)]
    (if (nil? per-page)
      (dom/remove-item key)
      (dom/set-item key (pr-str per-page)))))

(defn- current-page-key [table-id]
  (when table-id
    (str table-id "-current-page")))

(defn load-current-page
  [table-id]
  (when-let [key (current-page-key table-id)]
    (try
      (cljs.reader/read-string (dom/get-item key))
      (catch js/Error e
        (js/console.warn e)))))

(defn save-current-page
  [table-id current-page]
  (when-let [key (current-page-key table-id)]
    (if (nil? current-page)
      (dom/remove-item key)
      (dom/set-item key (pr-str current-page)))))

(defn- milestones-index-filter-key [project-id]
  (str project-id "-milestones-index-filter"))

(defn save-milestone-index-filtering [project-id filters]
  (when-let [key (milestones-index-filter-key project-id)]
    (dom/set-item key (pr-str filters))))

(defn load-milestone-index-filtering [project-id]
  (when-let [key (milestones-index-filter-key project-id)]
    (try
      (cljs.reader/read-string (dom/get-item key))
      (catch js/Error e
        (js/console.warn e)))))

(defn save-entity-form-active-tab
  [tab-id] 
    (if (nil? tab-id)
      (dom/remove-item "entity-form-active-tab") 
      (dom/set-item "entity-form-active-tab" tab-id)))

(defn load-entity-form-active-tab
  []
    (try
      (let [stored-value (dom/get-item "entity-form-active-tab")]
        (when stored-value 
          (keyword (cljs.reader/read-string stored-value))))
      (catch js/Error e
        (js/console.warn e)
        nil)))

(defn- linkage-key [user-id]
  (str "requirement-hide-define-linkage-message-" user-id))

(defn save-hide-define-linkage-message [value]
  (let [current-user @(re-frame/subscribe [::subs/current-user])
        user-id      (:id current-user)
        key          (linkage-key user-id)]
    (if value
      (dom/set-item key (pr-str value))
      (dom/remove-item key))))

(defn load-hide-define-linkage-message []
  (let [current-user @(re-frame/subscribe [::subs/current-user])
        user-id      (:id current-user)
        key          (linkage-key user-id)]
    (try
      (when-let [stored-value (dom/get-item key)]
        (cljs.reader/read-string stored-value))
      (catch js/Error e
        (js/console.warn e)
        false))))

(defn- label-reset-warning-key [user-id]
  (str "test-hide-label-reset-warning-" user-id))

(defn save-hide-label-reset-warning [value]
  (let [current-user @(re-frame/subscribe [::subs/current-user])
        user-id      (:id current-user)
        key          (label-reset-warning-key user-id)]
    (if value
      (dom/set-item key (pr-str value))
      (dom/remove-item key))))

(defn load-hide-label-reset-warning []
  (let [current-user @(re-frame/subscribe [::subs/current-user])
        user-id      (:id current-user)
        key          (label-reset-warning-key user-id)]
    (try
      (when-let [stored-value (dom/get-item key)]
        (cljs.reader/read-string stored-value))
      (catch js/Error e
        (js/console.warn e)
        false))))

(defn- section-collapsed-key [user-id entity-type section-id]
  (str "section-collapsed-" user-id "-" (name entity-type) "-" section-id))

(defn get-section-collapsed
  "Reads section collapsed state from localStorage.
   Returns default-collapsed? if no stored value exists."
  [entity-type section-id default-collapsed?]
  (let [current-user @(re-frame/subscribe [::subs/current-user])
        user-id      (:id current-user)
        stored       (dom/get-item (section-collapsed-key user-id entity-type section-id))]
    (if (some? stored)
      (= stored "true")
      default-collapsed?)))

(defn set-section-collapsed [entity-type section-id collapsed?]
  (let [current-user @(re-frame/subscribe [::subs/current-user])
        user-id      (:id current-user)]
    (dom/set-item (section-collapsed-key user-id entity-type section-id) (str collapsed?))))
